/**
 * @generated SignedSource<<def79dcc695aed55982a5c3059657ded>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarouselItemTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_viewer" | "ItemFolderWrapper_viewer" | "ItemHeartWrapper_viewer">;
  readonly " $fragmentType": "CarouselItemTile_viewer";
};
export type CarouselItemTile_viewer$key = {
  readonly " $data"?: CarouselItemTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarouselItemTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchFavorites"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarouselItemTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "fetchFavorites"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "userIds.0",
              "variableName": "userId"
            }
          ],
          "kind": "ListValue",
          "name": "userIds"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemFolderWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b7c587147e8350cb8d924e6c7e678bb1";

export default node;
